module.exports = __webpack_public_path__ + "media/images/premium-limited-offer-header-5f2b378c8dd40fec4839259181048b22.svg";